import { wideContentScaleControlZoomIn } from './ScaleControl.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { observer } from 'mobx-react';

let styles = require('./ScaleControl.scss');

export interface ScaleControlProps {
    onScaleUp: () => void;
}

@observer
class ScaleControl extends React.Component<ScaleControlProps, any> {
    private onClick = () => {
        this.props.onScaleUp();
    };

    render() {
        return (
            <Icon
                className={styles.scaleControl}
                title={loc(wideContentScaleControlZoomIn)}
                iconName={ControlIcons.FullScreen}
                onClick={this.onClick}
            />
        );
    }
}

export function MountScaleControl(scaleControlContainer: HTMLElement, onScaleUp: () => void) {
    ReactDOM.render(<ScaleControl onScaleUp={onScaleUp} />, scaleControlContainer);
}

export function UnmountScaleControl(scaleControlContainer: HTMLElement) {
    ReactDOM.unmountComponentAtNode(scaleControlContainer);
}
